import React from "react"

import { Fields } from ".."

import LoadingPlaceholder from "./LoadingPlaceholder"
import TextField from "./text/TextField"
import Selector from "./selectors/Selector"
import TimeField from "./time/TimeField"
import NumberField from "./number/NumberField"
import CheckboxField from "./checkbox/CheckboxField"
import DateField from "./date/DateField"
import ToggleButtonField from "./toggle/ToggleButtonField"
import TagPicker from "./tagPicker/TagPicker"
import RichTextField from "./richText/RichTextField"
import InlineAttachment from "./attachments/InlineAttachment"
import MapField from "./map/MapField"
import LocationField from "./location/LocationField"
import Section from "./section/Section"
import InlineButtonsField from "./inlineButtons/InlineButtonsField"

interface FieldProp {
    field?: Fields.Field
    isLoading: boolean
}

export const Field = ({ field, isLoading }: FieldProp): JSX.Element => {
    if (!field) {
        return <>{isLoading && <LoadingPlaceholder />}</>
    }
    switch (field.type) {
        case "smallText":
        case "longText":
        case "bigText":
            return <TextField field={field as Fields.TextField} />

        case "selector": {
            return <Selector {...(field as Fields.SelectorField)} />
        }

        case "tagPicker":
            return <TagPicker {...(field as Fields.TagPickerField)} />

        case "time":
            return <TimeField field={field as Fields.TimeField} />

        case "number":
            return <NumberField field={field as Fields.NumberField} />

        case "checkbox":
            return <CheckboxField field={field as Fields.CheckboxField} />

        case "date":
            return <DateField field={field as Fields.DateField} />

        case "toggle":
            return (
                <ToggleButtonField field={field as Fields.ToggleButtonField} />
            )
        case "richText":
            return <RichTextField field={field as Fields.RichTextField} />

        case "map":
            return <MapField field={field as Fields.MapField} />

        case "location":
            return <LocationField field={field as Fields.LocationField} />

        case "section":
            return <Section field={field as Fields.SectionField} />

        case "inlineAttachment":
            return (
                <InlineAttachment
                    field={field as Fields.InlineAttachmentField}
                />
            )
        case "inlineButtons":
            return (
                <InlineButtonsField
                    field={field as Fields.InlineButtonsField}
                />
            )

        default:
            return <></>
    }
}
